// Tim Hortons CSS

import { LayoutWidth, ZIndex } from './enums';
import { primitive } from './primitives';

export default {
  // Extra CSS Properties
  borderRadius: '4px',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1)',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  shadowOffset: '0px 2px',
  shadowRadius: '6px',

  // Color Styles
  color: {
    accent: primitive.th.$alwaysRed,
    alert: {
      default: {
        background: primitive.th.$coffeeBrown,
        text: primitive.$white,
      },
      info: {
        background: primitive.th.$coffeeBrown,
        text: primitive.$white,
      },
      success: {
        background: primitive.th.$coffeeBrown,
        text: primitive.$white,
      },
      warning: {
        background: primitive.$error,
        text: primitive.$white,
      },
      error: {
        background: primitive.$error,
        text: primitive.$white,
      },
    },
    codeBlockBackground: primitive.th.$coffeeBrown,
    contrastBackground: '',
    error: primitive.$error,
    errorHover: '',
    pricing: primitive.th.$alwaysRed,
    validated: primitive.th.$coffeeBrown,
    validatedHover: '',
    primary: primitive.th.$alwaysRed,
    primaryHover: primitive.th.$alwaysRedDarken10,
    secondary: primitive.th.$coffeeBrown,
    secondaryHover: '',
    teal: '',
    tertiary: primitive.th.$coffeeBrown,
    loyaltyHighlight: '',
    navLinkColor: {
      active: primitive.$white,
      hover: primitive.$white,
    },
    mobileNavButtonColor: primitive.th.$coffeeBrown,
    background: primitive.$white,
    black: primitive.th.$coffeeBrown,
    grey: {
      one: primitive.$blackOpacity30,
      two: primitive.th.$coffeeBrown,
      three: primitive.$blackOpacity30,
      four: primitive.$blackOpacity10,
      five: primitive.$blackOpacity10,
      six: primitive.$blackOpacity10,
      seven: primitive.$blackOpacity10,
      eight: primitive.$blackOpacity10,
      nine: '',
      ten: primitive.th.$donutCreamLighten20,
    },
    white: primitive.$white,
    cardBackground: primitive.$white,
    headerContrast: primitive.$white,
    highlight: '',
    disabledBorder: primitive.$blackOpacity30,
    disabledBackground: primitive.$blackOpacity30,
    disabledColor: primitive.$blackOpacity30,
    success: '',
    red: primitive.th.$alwaysRed,
    orange: '',
  },

  // Font Styles
  fontFamily: {
    base: '"sofia_pro", Helvetica, Arial, sans-serif',
    body: '"sofia_pro", Helvetica, Arial, sans-serif',
    alternative: '"sofia_pro", Helvetica, Arial, sans-serif',
    brand: '"autograph_regular", Helvetica, Arial, sans-serif',
  },

  // Font Weight Styles
  fontWeight: {
    black: 800,
    heavy: 'bold',
    normal: 'normal',
    light: 300,
  },

  // Font Transforms Styles
  textTransform: {
    headlines: 'none',
    body: 'none',
  },

  // Z Index Styles
  zIndex: {
    max: ZIndex.MAX,
    overlay: ZIndex.OVERLAY,
    top: ZIndex.TOP,
    normal: ZIndex.NORMAL,
    below: ZIndex.BELOW,
  },

  // Layout variables
  layout: {
    sectionMaxWidth: `${LayoutWidth.REGULAR}px`,
    smallerSectionMaxWidth: `${LayoutWidth.SMALL}px`,
    checkoutHeaderHeight: '57px',
    navHeight: {
      mobile: '56px',
      desktop: '78px',
    },
  },
};
